module.exports = __webpack_public_path__ + "static/media/final.b9bce2f7.jpg";